interface TransactionSummaryIpCouponSection {
  instapoints: {
    applyIpLink: string;
    ipContainerHeading: string;
    placeHolder: string;
    applyCTA: string;
    removeCTA: string;
    applyCTAToOffsetFees: string;
    offsetContainer: {
      discountedContainer: {
        discountAppliedMsg: string;
        feeOffHeading: string;
        feeOffDescription: string;
        discountClearCTA: string;
      };
      offerContainer: {
        feeApplyHeading: string;
        feeApplyDescription: string;
        discountApplyCTA: string;
      };
    };
  };
  coupons: {
    applyCouponLink: string;
    zeroCouponContainer: {
      zeroCouponHeading: string;
      zeroCouponDescription: string;
      zeroCouponApplyCTA: string;
      zeroCouponDiscountOfferMsg: string;
    };
    couponsAvailContainer: {
      couponAvailHeading: string;
      availableCouponTag: string;
      couponAvailViewCTA: string;
      couponsAvailableDiscountOfferMsg: string;
    };
    couponAppliedContainer: {
      couponAppliedHeading: string;
      couponAppliedDescription: string;
      couponAppliedClearCTA: string;
      couponAppliedDiscountMsg: string;
    };
  };
}

export type couponCMSDataType = {
  saveText: string;
  upToText: string;
  grabText: string;
  couponsHereCta: string;
  applyCouponFieldPlaceholder: string;
  applyCouponFieldCta: string;
  applyCouponTitle: string;
  couponsContainerHeading: string;
  transferAboveText: string;
  termsText: string;
  applyCta: string;
  couponAppliedWrapper: {
    youSend: string;
    clearCoupon: string;
    originalAmount: string;
    couponApplied: string;
    youSendOnly: string;
  };
  couponClearedModal: {
    heading: string;
    description: string;
    primaryCTA: string;
    secondaryCTA: string;
  };
  transactionSummaryIpCouponSection: TransactionSummaryIpCouponSection;
};
export type Coupon = {
  code: string;
  label: string;
  value: number;
  terms: string;
  source_currency: string;
  destination_currency: string | null;
  min_source_amount: number;
  end_date_time: string;
  disabled?: boolean;
};

export interface CouponsModalProps {
  onClose: () => void;
  couponCMSData: couponCMSDataType;
  couponList: Coupon[];
  isAppliedFromTnxSummaryPage?: boolean;
  onApplyCouponTxnSummaryPage?: (couponCode: string) => void;
}

/* Add disabled key if source amount entered is less than min souce amount required
    Sort coupons in descending order of value
    disabled coupons are put at the end of array
*/
export const formatCouponData = (
  couponData: Coupon[],
  sourceAmount: number,
  destinationCurrency: string | null
) => {
  return couponData
    .filter(
      (coupon) =>
        coupon.destination_currency === null || coupon.destination_currency === destinationCurrency
    )
    .map((coupon) => ({
      ...coupon,
      disabled: coupon.min_source_amount > sourceAmount
    }))
    .sort((a, b) => {
      if (a.disabled && !b.disabled) return 1;
      if (!a.disabled && b.disabled) return -1;
      return b.value - a.value;
    });
};

export const getActiveCouponCount = (coupons: Coupon[]): number => {
  return coupons.filter((coupon) => !coupon.disabled).length;
};
